import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentBriefing: { loading: false, error: null, data: null },
  archive: { loading: false, error: null, data: null },
  generating: { loading: false, error: null, data: null },
  schedule: { loading: false, error: null, data: null },
  featureFlags: { loading: false, error: null, data: null },
  pilotKpis: { loading: false, error: null, data: null },
};

const briefingSlice = createSlice({
  name: "briefing",
  initialState,
  reducers: {
    // Current briefing
    currentBriefingStart: (state) => {
      state.currentBriefing.loading = true;
      state.currentBriefing.error = null;
    },
    currentBriefingSuccess: (state, action) => {
      state.currentBriefing.loading = false;
      state.currentBriefing.data = action.payload;
      state.currentBriefing.error = null;
    },
    currentBriefingFailure: (state, action) => {
      state.currentBriefing.loading = false;
      state.currentBriefing.error = action.payload;
    },

    // Archive
    archiveStart: (state) => {
      state.archive.loading = true;
      state.archive.error = null;
    },
    archiveSuccess: (state, action) => {
      state.archive.loading = false;
      state.archive.data = action.payload;
      state.archive.error = null;
    },
    archiveFailure: (state, action) => {
      state.archive.loading = false;
      state.archive.error = action.payload;
    },

    // Generating
    generatingStart: (state) => {
      state.generating.loading = true;
      state.generating.error = null;
    },
    generatingSuccess: (state, action) => {
      state.generating.loading = false;
      state.generating.data = action.payload;
      state.generating.error = null;
      // Also update current briefing with the newly generated run
      state.currentBriefing.data = action.payload;
    },
    generatingFailure: (state, action) => {
      state.generating.loading = false;
      state.generating.error = action.payload;
    },

    // Schedule
    scheduleStart: (state) => {
      state.schedule.loading = true;
      state.schedule.error = null;
    },
    scheduleSuccess: (state, action) => {
      state.schedule.loading = false;
      state.schedule.data = action.payload;
      state.schedule.error = null;
    },
    scheduleFailure: (state, action) => {
      state.schedule.loading = false;
      state.schedule.error = action.payload;
    },

    // Feature flags
    featureFlagsStart: (state) => {
      state.featureFlags.loading = true;
      state.featureFlags.error = null;
    },
    featureFlagsSuccess: (state, action) => {
      state.featureFlags.loading = false;
      state.featureFlags.data = action.payload;
      state.featureFlags.error = null;
    },
    featureFlagsFailure: (state, action) => {
      state.featureFlags.loading = false;
      state.featureFlags.error = action.payload;
    },

    // Pilot KPIs
    pilotKpisStart: (state) => {
      state.pilotKpis.loading = true;
      state.pilotKpis.error = null;
    },
    pilotKpisSuccess: (state, action) => {
      state.pilotKpis.loading = false;
      state.pilotKpis.data = action.payload;
      state.pilotKpis.error = null;
    },
    pilotKpisFailure: (state, action) => {
      state.pilotKpis.loading = false;
      state.pilotKpis.error = action.payload;
    },
  },
});

export const {
  currentBriefingStart, currentBriefingSuccess, currentBriefingFailure,
  archiveStart, archiveSuccess, archiveFailure,
  generatingStart, generatingSuccess, generatingFailure,
  scheduleStart, scheduleSuccess, scheduleFailure,
  featureFlagsStart, featureFlagsSuccess, featureFlagsFailure,
  pilotKpisStart, pilotKpisSuccess, pilotKpisFailure,
} = briefingSlice.actions;

export default briefingSlice.reducer;
